var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReciever(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.6,
    height: 15.551,
    viewBox: "0 0 15.6 15.551",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1,
    transform: "translate(-7.08 -7.21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_37398",
    "data-name": "Tracciato 37398",
    d: "M22.652,19.036l-.528,2.549a1.445,1.445,0,0,1-1.306,1.144c-.3.021-.526.032-.692.032-7.19,0-13.046-6.14-13.046-13.685V8.617A1.441,1.441,0,0,1,8.519,7.21h2.646a1.439,1.439,0,0,1,1.412,1.172l.572,3.05a1.435,1.435,0,0,1-.334,1.216l-1.022,1.163a12.644,12.644,0,0,0,4.175,4.034l2.022-1.3a1.443,1.443,0,0,1,1.321-.124l2.478,1A1.441,1.441,0,0,1,22.652,19.036Z",
    fill: "#979797"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReciever);
export default __webpack_public_path__ + "static/media/reciever.b5a3b0f18478278d701d3ef24a184c13.svg";
export { ForwardRef as ReactComponent };